<template>
  <div class="empty-image">
    <img src="/resources/images/empty/no-image.svg" alt="No image">
    <span>No Image</span>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.empty-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 368px;
  padding: 28px;
  background-color: #fafafa;
  border: 1px dashed #e4e9f0;
  border-radius: 4px;
}

.empty-image span {
  font-size: 12px;
  line-height: 21px;
  text-align: center;
  color: #BFBFBF;
}
</style>
